import { useTranslation } from 'react-i18next';

import Textarea from '../../../../components/Textarea/Textarea';
import TextField from '../../../../components/TextField/TextField';
import { DESCRIPTION_LENGTH } from '../../../../constants/general';
import SurveyAnswerItemPanel from './SurveyAnswerItemPanel';

import type { ISurveyAnswerQuestionData } from '../interfaces/ISurveyAnswerQuestion';

import styles from '../scss/SurveyAnswer.module.scss';

function SurveyAnswerPanel({
  title,
  name,
  description,
}: ISurveyAnswerQuestionData) {
  const { t } = useTranslation();

  return (
    <SurveyAnswerItemPanel
      title={title.length > 0
        ? t(`materialityAssessment.insightType.${title}`)
        : t('materialityAssessment.details')}
    >
      <div className={styles.surveyWrapper}>
        <TextField
          name="name"
          value={name}
          label={t('materialityAssessment.surveyName')}
          className={styles.surveyName}
          placeholder={t('materialityAssessment.placeholderName')}
          onChange={() => {}}
        />
        <Textarea
          name="description"
          value={description}
          label={t('materialityAssessment.surveyDescription')}
          className={styles.description}
          placeholder={t('materialityAssessment.placeholderDescription')}
          charactersLimit={DESCRIPTION_LENGTH}
          onChange={() => {}}
        />
      </div>
    </SurveyAnswerItemPanel>
  );
}

export default SurveyAnswerPanel;
